import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGitlab = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "4.5 4.5 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M18.7658 10.5414L18.7467 10.4893L16.841 5.32714C16.8029 5.22601 16.7344 5.14081 16.6453 5.08197C16.5564 5.02282 16.4522 4.99493 16.3466 5.00076C16.2415 5.00658 16.1405 5.04642 16.0582 5.11446C15.9764 5.18311 15.9174 5.27597 15.8896 5.38078L14.6029 9.4694H9.39717L8.11049 5.38078C8.08274 5.27597 8.02371 5.18311 7.94194 5.11446C7.85959 5.04642 7.75864 5.00658 7.65355 5.00076C7.54788 4.99493 7.44368 5.02282 7.35483 5.08197C7.26569 5.14081 7.19721 5.22601 7.15913 5.32714L5.25346 10.4896L5.23427 10.5414C4.66959 12.0707 5.15073 13.7995 6.4082 14.787C6.41055 14.7885 6.41262 14.7903 6.41498 14.7922L6.43181 14.8053L9.33459 17.0616L10.7703 18.19L11.6441 18.8759C11.8545 19.0414 12.1456 19.0414 12.356 18.8759L13.2298 18.19L14.6652 17.0616L17.5851 14.7922C17.5878 14.79 17.5901 14.7882 17.5928 14.786C18.8494 13.7986 19.3302 12.0704 18.7658 10.5414Z",
			fill: "#E24329"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.7658 11.0476L18.7467 11C17.8012 11.1841 16.9304 11.5632 16.1848 12.092C16.1727 12.1004 13.919 13.6249 12 15C13.4248 16.0212 15 17 15 17L17.5851 14.9282C17.5878 14.9262 17.5901 14.9246 17.5928 14.9226C18.8494 14.0211 19.3302 12.4434 18.7658 11.0476Z",
			fill: "#FC6D26"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9 17L10.616 18.1959L11.5995 18.8768C11.8364 19.0411 12.164 19.0411 12.4009 18.8768L13.3843 18.1959L15 17C15 17 13.6039 16.1104 12.0002 15C10.3961 16.1104 9 17 9 17Z",
			fill: "#FCA326"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.81499 12.0918C7.06967 11.5632 6.1992 11.1838 5.25346 11L5.23427 11.0473C4.66959 12.4435 5.15073 14.0218 6.40818 14.9233C6.41054 14.9247 6.41261 14.9264 6.41497 14.9281L6.4318 14.9401L9 17C9 17 10.5749 16.0213 12 15C10.0811 13.6248 7.8271 12.1002 7.81499 12.0918Z",
			fill: "#FC6D26"
		})
	]
});
export default SvgGitlab;
